import { api } from './client'

export const agreementsApi = {
    create:      (data)         => api.post('/agreements', data),
    getPending:  ()             => api.get('/agreements/pending'),
    acknowledge: (agreementId)  => api.post(`/agreements/${agreementId}/acknowledge`, {}),
}
